import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconCheck: React.FC<IconProps> = ({ color = '#15C24C', width = 41, height = 40 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 41 40"
            fill="none"
        >
            <path
                d="M35.5 20C35.5 28.2843 28.7843 35 20.5 35C12.2157 35 5.5 28.2843 5.5 20C5.5 11.7157 12.2157 5 20.5 5C22.8534 5 25.0803 5.54198 27.0625 6.50794M32.6875 10.625L19.5625 23.75L15.8125 20"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconCheck;
